<template>
    <div class="gerenciamento-parametros">
        <g-card
            largura="calc(100vw - 20px)"
            altura="fit-content"
            class="card-gerenciamento-parametros"  
        >
            <template #cabecalho>
                <div class="card-gerenciamento-parametros-titulo">Parâmetros</div>
            </template>            
            <g-form>
                <div class="seguranca">
                    <p class="card-subtitulo">Segurança</p>       
                    <div class ="seguranca-content">
                        <div class="input-container" id="input1">
                            <div class="g-input-label">Trocar senha após n dias</div>
                            <PInputText
                                class="input"
                                placeholder="Insira o número de dias"
                                v-model="novoGerenciamentoParametros.numeroSenha"

                            />
                        </div>
                        <div class="input-container" id="input2">
                            <div class="g-input-label">Número de tentativas</div>
                            <PInputText
                                class="input"
                                placeholder="Insira o número de tentativas"
                                v-model="novoGerenciamentoParametros.numeroTentativas"
                            />
                        </div>
                        <div class="input-container" id="input3">
                            <div class="g-input-label">Grupo a ser isentado do bloqueio</div>
                        <VMultiSelect
                                class="input"
                                placeholder="Selecione o grupo"
                                :filter="true"
                                optionLabel="nomeGrupo"
                                v-model="GruposSelecionados"
                                :options="grupoArray"
                                optionValue="id"
                            >
                        </VMultiSelect>
                        </div>
                    </div>
                </div>
            </g-form>
            <hr/>
            <g-form>
                <div class="log">
                    <p class="card-subtitulo">Log</p>
                    <div class="log-content">
                        

                    </div>
                    <div class="input-container" id="limpar-auto">
                            <div class="g-input-label">Limpar automaticamente após n dias</div>
                            <PInputText
                                class="input"
                                placeholder="Insira o número de dias"
                                v-model="novoGerenciamentoParametros.numeroDiasLimpezaLog"
                            />
                    </div>
                </div>
            </g-form>
            <hr/>
            <g-form>
                <div class="Automação">
                    <p class="card-subtitulo">Automação</p>
                    <div class="seguranca-content">
                        <div class="input-container" id="input-forma-pagamento">
                            <div class="g-input-label">Forma de Pagamento</div>
                            <PDropDown
                                class="input"
                                :filter="true"
                                optionLabel="formaPagamentoAutomacao"
                                optionValue="id"
                                :options="formaPagamentoArray"
                                placeholder="Selecione a forma de pagamento"
                                v-model="FormaPagamentoSelecionada"
                            >
                            </PDropDown>
                        </div>
                        <div class="input-container" id="input-tipo-frete">
                            <div class="g-input-label">Tipo de Frete</div>
                            <PDropDown
                                class="input"
                                :filter="true"
                                optionLabel="text"
                                optionValue="value"
                                :options="tipoFreteArray"
                                placeholder="Tipo de Frete"
                                v-model="TipoFreteSelecionado"
                            />
                        </div>
                        <div class="input-container" id="input-tipo-onda">
                            <div class="g-input-label">Tipo de Onda</div>
                            <PDropDown
                                class="input"
                                :filter="true"
                                optionLabel="text"
                                optionValue="value"
                                :options="tipoOndaArray"
                                placeholder="Tipo de Onda"
                                v-model="TipoOndaSelecionado"
                            />
                        </div>
                    </div>
                </div>
            </g-form>
            <hr/>
            <g-form>
                <div class="log">
                    <p class="card-subtitulo">   
                        <PCheckBox 
                    name="extr"
                    value="exterior-value"
                    :binary="true"
                    v-model="novoGerenciamentoParametros.tapumeAtivo"
                    ></PCheckBox>
                    Tapume </p>
                    <!-- <div class="log-content">
                        <PToggleButton v-model="checked" />
                        
                        
                    </div> -->
                    
                </div>
            </g-form>
            <hr/>
            <g-form class="button-representatnes-crm-container" >
                
                <div v-if="carregandoEnvioRepresentatesCrm">
                    <g-button
                    
                    negritoTexto                    
                    @click="enviarRepresentanteCRM"
                    :sombreado="false"
                    tamanhoTexto="12px"
                    altura="35px"
                    tipo="cinza"
                >
                <div class="button-loading">
                    Realizando envio:
                    <i class="pi pi-spin pi-spinner"></i>
                </div>

            </g-button>
                
                    
                </div>
                
                <g-button
                    v-else
                    negritoTexto                    
                    @click="enviarRepresentanteCRM"
                    :sombreado="false"
                    tamanhoTexto="12px"
                    altura="35px"
                    tipo="cinza"

                >
                    Enviar Representantes ao CRM
                </g-button>
            </g-form>
            <hr/>
            <g-form>
                <div class="button-container">
                        <g-button
                            class="button"                     
                            negritoTexto                    
                            tamanhoTexto="12px"
                            altura="35px"
                            @click="updateParametros"
                            :sombreado="false"
                        >
                            GRAVAR
                        </g-button>
                    </div>
            </g-form>
        </g-card>
    </div>
</template>

<script>
import GerenciamentoParametros from './GerenciamentoParametros.js' 
export default GerenciamentoParametros
</script>

<style scoped>
.button-loading{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.button-representatnes-crm-container{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    
}
div#limpar-auto{
    width: 25rem;
    display:none;
}
.icon-question{
    background-color: #FCB315;
    color:#FFFFFF;
    border-radius: 100%;
    padding:2px;
}
.seguranca,.upload,.log{
    margin: 0px 10px 0px 10px;
}
.button{
    margin: 10px 0 10px 0;
    width: 100%;
}
.input{
    width: 100%;
    margin: 10px 0 10px 0;
}
.upload-content{
    /* background-color:orange; */
    display: flex;
    flex-direction:column ;
    text-align: left;
}
.input-container{
    /* background-color:gray ; */
    text-align: left;
    width: 100%; 
}
.label-checkBox{
    /* background-color:tomato; */
    justify-self: center;
}
.label-checkBox{
  font-size: 0.95rem;
  padding-left:5px;
  color:#8A8A8A;
  margin: 10px 0 10px 0; 
}
.seguranca-content{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    align-self: center;
}
.checkBox-inputs{
  width: 100%;
  flex-direction: column;
  text-align: left;  
  display: flex;
}
.card-subtitulo{
    text-align: left;
    color: #4f2c19;
    font-weight: bold;
    font-size: 1.2rem;
}
.gerenciamento-parametros{
    /* background-color:tomato ; */

    width: 100vw;
    margin:0 auto;
}
.input-container-checkBox{
    /* background-color:crimson ; */
    text-align: left;
    width: 100%;
    display: flex;
    align-items: center;
}
.show-on-desktop{
    display:none;
}
.card-gerenciamento-parametros{
    /* background-color:orange ; */
    display: flex;
}
.card-gerenciamento-parametros-titulo{
    /* background-color:tomato; */
    text-align: left;
    color: #4f2c19;
    font-weight: bold;
    font-size: 1.2rem;
}
@media (min-width:1025px) { 
    .button{
        width:40%;
    }
    
    div#extension-input{
        width: 250%;
    }
    div#input1{
        width:120%
    }
    div#input2{
        width:150%
    }
    div#input3{
        width:190%
    }
    .show-on-desktop{
        display: inline-table;
    }
    div#limpar-auto{
        display: block;
    }  
    .input-container{
        margin:0 15px 0 0;
    }
    .checkBox-inputs{
        align-items: center;
    }

    .button-container{
        display:flex;
        width:40%;
        flex-direction: row;
        justify-content: center;
        margin: 0 auto;
    }
    .seguranca-content,.upload-content,.log-content,.checkBox-inputs{
        flex-direction: row;
        align-items: flex-end;
    }
}

</style>
